const currencyDigits = new Map<string, number>();

export function getReturnCurrencyDigits(currency?: string): number {
  const code = currency?.trim().toUpperCase() || 'USD';
  if (!/^[A-Z]{3}$/.test(code)) return 2;
  const cached = currencyDigits.get(code);
  if (cached !== undefined) return cached;
  try {
    const digits = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: code,
    }).resolvedOptions().maximumFractionDigits;
    currencyDigits.set(code, digits);
    return digits;
  } catch {
    return 2;
  }
}

export function roundReturnMoney(amount: number, currency?: string): number {
  const factor = 10 ** getReturnCurrencyDigits(currency);
  const magnitude = Math.abs(amount);
  const rounded =
    Math.round((magnitude + Number.EPSILON * magnitude) * factor) / factor;
  return rounded === 0 ? 0 : Math.sign(amount) * rounded;
}

export function parseReturnFeeAmount(value: unknown): number | null {
  if (typeof value === 'string') {
    const decimal = value.trim();
    if (!/^\d+(?:\.\d+)?$/.test(decimal)) return null;
    value = Number(decimal);
  }
  return typeof value === 'number' && Number.isFinite(value) && value >= 0
    ? value
    : null;
}

export function formatReturnDecimal(amount: number, currency?: string): string {
  return amount.toFixed(getReturnCurrencyDigits(currency));
}
